import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons';
import { COLORS } from 'constants/design';
import styled from 'styled-components';

export const Container = styled.div`
  margin: 16px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-right: 48px;
  margin-left: 48px;
  margin-top: 32px;
`;

export const StyledArrowBackIos = styled(ArrowBackIos)`
  margin-right: 25px;
  width: 15px;
`;

export const StyledArrowForwardIos = styled(ArrowForwardIos)`
  margin-left: 25px;
  width: 15px;
  fill: ${COLORS.WHITE};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;
export const StyledDiv = styled.div`
  position: absolute;
  margin-left: auto;
  right: 3%;
`;
